import { render } from "./generalStatistics.vue?vue&type=template&id=c4831ed4&scoped=true"
import script from "./generalStatistics.vue?vue&type=script&lang=js"
export * from "./generalStatistics.vue?vue&type=script&lang=js"

import "./generalStatistics.vue?vue&type=style&index=0&id=c4831ed4&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4831ed4"]])

export default __exports__